import axios from 'axios'
import { getToken } from '@/libs/util'
import { LoadingBar, Notice } from 'view-design'
import config from '@/config'
import i18n from '@/locale'

import _ from 'lodash'

// const statusMsgs = {
//   401: '401',
//   422: 'Unprocessable Entity',
//   500: '500'
// }

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    return {
      baseURL: this.baseUrl,
      headers: {
        Accept: config.http.headers.Accept,
        'Content-Type': 'application/json;',
        Authorization: 'Bearer ' + getToken(),
        Environment: config.environment
      }
    }
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      LoadingBar.start()
      return config
    }, error => {
      LoadingBar.error()
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status, headers, request, config } = res
      LoadingBar.finish()
      return { data, status, headers, request, config }
    }, error => {
      LoadingBar.error()
      if (status !== 200) {
        var errorTitle = ''
        var errorContent = ''
        var replaceContexts = null
        // Validation errors
        if (!_.isEmpty(error.response.data.errors)) {
          _.forEach(error.response.data.errors, (errorItem) => {
            if (_.isArray(errorItem)) {
              errorContent += `<div>${errorItem.join('</div><div>')}</div>`
            } else {
              errorContent += `<div>${errorItem}</div>`
            }
          })
          errorTitle = error.response.data.message
        } else {
          errorTitle = ''
          errorContent = error.response.data.message
          // If error message is an json like string, will replace contexts, this is usefull with message translation
          try {
            var msgObj = JSON.parse(error.response.data.message)
            if (typeof msgObj === 'object') {
              errorContent = errorContent.message
            }
            if (typeof msgObj.context === 'object') {
              replaceContexts = msgObj.context
            }
          } catch (e) {
          // do nothing
          }
        }

        // Message with error code translation
        if (error.response.data.code > 10000) {
          errorTitle = ''
          errorContent = i18n.t(`error_notice.${error.response.data.code.toString()}`)
        }

        if (replaceContexts && typeof replaceContexts === 'object') {
          Object.keys(replaceContexts).forEach(function(contextName) {
            errorContent = errorContent.replace(`{${contextName}}`, replaceContexts[contextName])
          })
        }

        const noticeConfig = {
          // content: _.get(statusMsgs, status, errorContent),
          title: errorTitle,
          desc: errorContent,
          duration: 100,
          closable: true
        }
        if (status < 500) {
          Notice.warning(noticeConfig)
        } else {
          Notice.error(noticeConfig)
        }
      }
      this.destroy(url)
      return Promise.reject(error)
    })
  }
  request(options) {
    const instance = axios.create()
    const insideConfig = this.getInsideConfig()
    if (options.headers) {
      insideConfig.headers = Object.assign(insideConfig.headers, options.headers)
      delete options.headers
    }
    options = Object.assign(insideConfig, options)
    this.interceptors(instance, options.url)
    // options.data = JSON.stringify(options.data)
    return instance(options)
  }
}
export default HttpRequest
